import { Helmet } from "react-helmet-async";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  TextField,
  InputAdornment,
  Autocomplete,
  FormControl,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AutorenewRoundedIcon from "@mui/icons-material/AutorenewRounded";
import { PATH_DASHBOARD } from "routes/paths";
import Iconify from "components/iconify";
import CustomBreadcrumbs from "components/custom-breadcrumbs";
import { useSettingsContext } from "components/settings";
import CustomTable from "components/CustomTable";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { chaptercolumns } from "./utils";
import { LoadingButton } from "@mui/lab";
import MenuPopupSpeedLearnMap from "./component/MenuPopupSpeedLearnMap";
import {
  getAllSpeedLearnMapAsync,
  deleteSpeedLearnMapAsync,
} from "redux/speedlearn/speedlearnmap/speedlearnmap.async";
import { emptySpeedLearnMap } from "redux/speedlearn/speedlearnmap/speedlearnmap.slice";
import { getClassWithBoardFilterAsync } from "redux/filter/filter.async";
import { toast } from "react-hot-toast";
import { toastoptions } from "utils/toastoptions";
import ConfirmDialog from "components/confirm-dialog/ConfirmDialog";
import _ from "lodash";

export default function SpeedLearnMap() {
  const { themeStretch } = useSettingsContext();
  const dispatch = useDispatch();
  const [openPopover, setOpenPopover] = useState(null);
  const [speedLearnInfo, setSpeedLearnInfo] = useState("");
  const location = useLocation();
  const { newPageNo } = location?.state || {};
  const [paginationpage, setPaginationpage] = useState(
    newPageNo !== undefined ? newPageNo : 1
  );
  const [perPageNumber, setperPageNumber] = useState(10);
  const [searchSubject, setSearchSubject] = useState("");
  const [searchChapter, SetSearchChapter] = useState("");
  const [searchClass, setSearchClass] = useState([]);
  const [isFind, setIsFind] = useState(false);
  const { modulePermit } = useSelector((state) => state.menuPermission);
  const { speedLearnMapLoader, getAllSpeedLearnMap, speedLearnMapDelete } =
    useSelector((state) => state.speedlearnmap);

  const tabTitle = useSelector(
    (state) => state?.admin?.adminSetting?.siteTitle
  );
  const [openConfirm, setOpenConfirm] = useState(false);

  const InitialChapters = ({ pageNo, paginateNo, isFindManual, isReset }) => {
    if (pageNo && paginateNo) {
      setPaginationpage(pageNo);
      setperPageNumber(paginateNo);
    }
    let payload = {};
    if (isFind || isFindManual) {
      payload = {
        subject: searchSubject,
        chapter: searchChapter,
      };
    }
    if (isReset) {
      delete payload.subject;
      delete payload.chapter;
    }
    dispatch(
      getAllSpeedLearnMapAsync({
        page: pageNo || paginationpage,
        limit: paginateNo || perPageNumber,
        status: "all",
        ...payload,
      })
    );
  };
  const resetFilter = () => {
    setIsFind(false);
    setSearchClass([]);
    setSearchSubject("");
    SetSearchChapter("");
    InitialChapters({
      pageNo: 1,
      paginateNo: 10,
      status: "all",
      isReset: true,
    });
  };

  // POPUPOVER
  const handleClosePopover = () => {
    setOpenPopover(null);
  };
  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget);
  };

  // PAGINATION
  const handlePageChange = (page) => {
    setPaginationpage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setperPageNumber(newPerPage);
  };

  useEffect(() => {
    InitialChapters({});
  }, [paginationpage, perPageNumber]);

  useEffect(() => {
    dispatch(getClassWithBoardFilterAsync({}));
  }, []);

  useEffect(() => {
    if (speedLearnMapDelete.status === 200) {
      toast.success(speedLearnMapDelete.message, toastoptions);
      dispatch(emptySpeedLearnMap());
      setOpenConfirm(false);
      InitialChapters({});
    }
  }, [speedLearnMapDelete]);

  return (
    <Container maxWidth={themeStretch ? "lg" : false}>
      <Helmet>
        <title>Speed Learn | {`${tabTitle}`}</title>
      </Helmet>
      <CustomBreadcrumbs
        links={[
          { name: "Speed Learn", href: "" },
          { name: "Speed Learn Map", href: "" },
        ]}
        action={
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
              flexWrap: "wrap",
              mt: 1,
            }}
          >
            {/* <TextField
              size="small"
              sx={{ width: 150, mr: 2, mb: { xs: 1, sm: 0 } }}
              value={searchSubject}
              onChange={(e) => setSearchSubject(e.target.value)}
              placeholder="Subject"
              InputProps={{
                sx: { borderRadius: "10px !important" },
                startAdornment: (
                  <InputAdornment position="start">
                    <Iconify
                      icon="eva:search-fill"
                      sx={{ color: "text.disabled" }}
                    />
                  </InputAdornment>
                ),
              }}
            /> */}
            <Box>
              {/* <Button
                sx={{ borderRadius: "7px", mr: 1 }}
                variant="contained"
                onClick={() => {
                  setIsFind(true);
                  InitialChapters({
                    pageNo: 1,
                    paginateNo: 10,
                    isFindManual: true,
                  });
                }}
              >
                Filter
              </Button> */}
              <Button
                sx={{ borderRadius: "7px", mr: 1 }}
                variant="contained"
                onClick={resetFilter}
              >
                <AutorenewRoundedIcon />
              </Button>

              <Button
                sx={{ borderRadius: "7px", mr: 1 }}
                to={PATH_DASHBOARD.createspeedlearnmap}
                component={RouterLink}
                variant="contained"
                disabled={!Boolean(modulePermit?.add)}
              >
                <AddIcon />
              </Button>
            </Box>
          </Box>
        }
      />
      <CustomTable
        columnheight="30px"
        loader={speedLearnMapLoader}
        data={getAllSpeedLearnMap?.data}
        columns={chaptercolumns({
          openPopover,
          handleOpenPopover,
          setSpeedLearnInfo,
          paginationpage,
        })}
        totalcount={getAllSpeedLearnMap?.count}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        expandableRows={false}
        expandableRowsComponent={ExpandedComponent}
        defaultPage={paginationpage}
      />
      <MenuPopupSpeedLearnMap
        openPopover={openPopover}
        handleClosePopover={handleClosePopover}
        speedLearnInfo={speedLearnInfo}
        paginationpage={paginationpage}
        setOpenConfirm={setOpenConfirm}
      />
      <ConfirmDialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        title="Delete"
        content="Are you sure want to delete?"
        action={
          <LoadingButton
            variant="contained"
            color="error"
            loading={speedLearnMapLoader}
            onClick={() =>
              dispatch(deleteSpeedLearnMapAsync(speedLearnInfo.id))
            }
          >
            Delete
          </LoadingButton>
        }
      />
    </Container>
  );
}

const ExpandedComponent = ({ data }) => (
  <pre>{JSON.stringify(data, null, 2)}</pre>
);
